export function getDeviceId() {
  let id = localStorage.getItem("fluxocrm_device_id");
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Math.random().toString(36).slice(2)}-${Date.now()}`);
    localStorage.setItem("fluxocrm_device_id", id);
  }
  return id;
}

export function getDeviceInfo() {
  const nav = window.navigator;
  return [
    nav.platform || "",
    `${window.screen?.width || 0}x${window.screen?.height || 0}`,
    Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    nav.language || "",
    nav.hardwareConcurrency || 0,
  ].join("|");
}
